/*
 * Copyright 2018 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

const Chacmool = {
  type: 'annotation',
  label: 'Chacmool',
  position: [0.34, 0.32, 0.2],
  normal: [0, 0, 1],
  action: () => {
    let dialog = document.getElementById('Chacmool');
    if (!dialog.showModal) {
      dialogPolyfill.registerDialog(dialog);
    }
    dialog.showModal();
    dialog.querySelector('.close').addEventListener('click', () => {
      dialog.close();
    });
  },
};

const Cuauhxicalli = {
  type: 'annotation',
  label: 'Cuauhxicalli',
  position: [-0.07, 0.49, -0.01],
  normal: [0, 1, 0],
  action: () => {
    let dialog = document.getElementById('Cuauhxicalli');
    if (!dialog.showModal) {
      dialogPolyfill.registerDialog(dialog);
    }
    dialog.showModal();
    dialog.querySelector('.close').addEventListener('click', () => {
      dialog.close();
    });
  },
};

const Head = {
  type: 'annotation',
  label: 'Orientation',
  position: [0.34, 0.658701, 0.13],
  normal: [0, 0, 1],
  action: () => {
    let dialog = document.getElementById('Head');
    if (!dialog.showModal) {
      dialogPolyfill.registerDialog(dialog);
    }
    dialog.showModal();
    dialog.querySelector('.close').addEventListener('click', () => {
      dialog.close();
    });
  },
};

const Posture = {
  type: 'annotation',
  label: 'Seated Posture',
  billboard: [true, true],
  position: [0.190047, 0.217685, -0.245],
  normal: [0, 1, -1],
  action: () => {
    let dialog = document.getElementById('Posture');
    if (!dialog.showModal) {
      dialogPolyfill.registerDialog(dialog);
    }
    dialog.showModal();
    dialog.querySelector('.close').addEventListener('click', () => {
      dialog.close();
    });
  },
};

const Symbols = {
  type: 'annotation',
  label: 'Iconography',
  billboard: [true, true],
  position: [-0.25, 0.2, 0.19],
  normal: [0, 0, 1],
  action: () => {
    let dialog = document.getElementById('Symbols');
    if (!dialog.showModal) {
      dialogPolyfill.registerDialog(dialog);
    }
    dialog.showModal();
    dialog.querySelector('.close').addEventListener('click', () => {
      dialog.close();
    });
  },
};

const Feet = {
  type: 'annotation',
  label: 'Red feet',
  billboard: [true, true],
  position: [-0.475, 0.1, 0.135],
  normal: [-1, 0, 1],
  action: () => {
    let dialog = document.getElementById('Feet');
    if (!dialog.showModal) {
      dialogPolyfill.registerDialog(dialog);
    }
    dialog.showModal();
    dialog.querySelector('.close').addEventListener('click', () => {
      dialog.close();
    });
  },
};

export { Chacmool };
export { Cuauhxicalli };
export { Head };
export { Posture };
export { Symbols };
export { Feet };



// WEBPACK FOOTER //
// ./src/data/Annotations.js